import { render, staticRenderFns } from "./Nombre.vue?vue&type=template&id=32f9c50c&scoped=true&"
import script from "./Nombre.vue?vue&type=script&lang=js&"
export * from "./Nombre.vue?vue&type=script&lang=js&"
import style0 from "./Nombre.vue?vue&type=style&index=0&id=32f9c50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f9c50c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
